import { ReactNode } from 'react';

import LockIcon from '@/assets/icons/account/lock-kyc.svg';
import { P } from '@/components/shared/Typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils/cn';

interface I_AlertBannerProps {
  /** The warning/info text content */
  text: string | ReactNode;
  /** Whether to show the action button */
  showButton?: boolean;
  /** Text for the action button */
  buttonText?: string;
  /** Handler for button click */
  onButtonClick?: () => void;
  /** Disable the button (e.g. while loading) */
  buttonDisabled?: boolean;
  /** Show loading state on the button */
  buttonLoading?: boolean;
  /** visual variant */
  variant?: 'destructive' | 'default';
  /** Optional className */
  className?: string;
}

export const AlertBanner = ({
  text,
  showButton = false,
  buttonText,
  onButtonClick,
  buttonDisabled = false,
  buttonLoading = false,
  variant = 'destructive',
  className
}: I_AlertBannerProps) => {
  return (
    <div
      className={cn(
        'flex w-full justify-between flex-col md:flex-row ring-1 py-6 px-8 gap-5 transition-colors',
        variant === 'destructive'
          ? 'ring-ring-destructive bg-destructive-half'
          : 'ring-border bg-kyc-blue',
        className
      )}
    >
      <P
        icon={<LockIcon className="mr-2.5" />}
        className="flex justify-center items-center text-sm font-bold"
      >
        {text}
      </P>
      {showButton && buttonText && (
        <Button
          variant="secondary"
          onClick={onButtonClick}
          disabled={buttonDisabled}
          isLoading={buttonLoading}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};
